"use client";

import { c as _c } from "react/compiler-runtime";
import { Link } from "@heroui/react";
import Image from "next/image";
import { useScopedI18n } from "@/lib/i18n";
import HeadImage from "@/assets/head.png";
import { Socials } from "../socials";
export function Hero() {
  const $ = _c(14);
  const t = useScopedI18n("landing.hero");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      backgroundImage: "radial-gradient(120% 120% at 0% 0%, oklch(91% 0.055 78), oklch(82% 0.07 72) 55%, oklch(70% 0.08 66))"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="relative"><div className="relative h-40 overflow-hidden rounded-large" style={t0}><div className="absolute inset-0 opacity-[0.18] mix-blend-soft-light" style={{
          backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
        }} /></div><Image className="-bottom-4 absolute left-4 size-25 rounded-large ring-4 ring-background" src={HeadImage} alt="Bruno" width={100} height={100} draggable={false} /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex justify-between"><div className="leading-none"><h1 className="font-semibold text-2xl">Bruno Lepis</h1><p className="text-md text-muted">@itsbrunodev</p></div><Socials /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("description");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <p className="mt-3">{t3}</p>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t("more");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <Link className="mt-2 text-base" href="/about">{t5}</Link>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <div className="flex flex-col gap-8">{t1}<div className="px-4">{t2}{t4}{t6}</div></div>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}